import CircularProgress, { CircularProgressProps } from '@material-ui/core/CircularProgress';

import './ActivityIndicator.css';

//
// --- Types ---

export interface ActivityIndicatorProps extends Pick<CircularProgressProps, 'color' | 'size'> {
  'data-testid'?: string;
  hideMessage?: boolean;
  /** text displayed under MUI CircularProgress icon */
  message?: string;
}

//
// --- ActivityIndicator Component ---

/**
 * ActivityIndicator is a generic component for to be displayed when the UI needs to wait for
 * some short of activity to complete. Typically, this is while API calls are running.
 *
 * The component displays a loading spinner and some text below to help inform the user. By default,
 * "Loading ..." text is displayed, but that can be customized with props.
 */
const ActivityIndicator: React.FC<ActivityIndicatorProps> = ({
  'data-testid': dataTestId = 'activity-indicator',
  color = 'primary',
  hideMessage = false,
  message,
  size = 40
}) => (
  <div className="activity-indicator" data-testid={dataTestId}>
    <CircularProgress color={color} size={size} />
    {!hideMessage && <p className="activity-indicator-text">{message ? message : 'Loading'}</p>}
  </div>
);

export default ActivityIndicator;
